import { FunctionComponent, useContext } from "react";
import { Text } from "@kanda-libs/ks-design-library";
import LineItemContext from "components/job/LineItem/LineItemContext";
import { SKELETONS } from "components/job/LineItem/constants";

export interface QuantityProps {}

const Quantity: FunctionComponent<QuantityProps> = () => {
  const { quantity, classNames } = useContext(LineItemContext);

  return (
    <Text
      className={classNames.quantity}
      text={quantity}
      skeletonProps={SKELETONS.quantity}
    />
  );
};

export default Quantity;
